window.FormaPagamentoItemView = Backbone.Marionette.ItemView.extend({
    template: "#template-forma-pagamento-item",
    tagName: "option",

    initialize: function(options) {
        this.app = options.app;
        this.parent = options.parent;
    },


    onRender: function() {
        this.$el.attr("value", this.model.get("Codigo"));
    },
});


window.FormaPagamentoView = Backbone.Marionette.CompositeView.extend({
    template: "#template-forma-pagamento",
    childView: FormaPagamentoItemView,
    childViewContainer: "#lista-forma-pagamento",

    events: {
        'change #lista-forma-pagamento': "carregarTiposDocumento"
    },

    initialize: function(options) {
        this.app = options.app;
        this.carregarTiposDocumentoCallback = options.carregarTiposDocumentoCallback;
    },

    carregarTiposDocumento: function(e) {

        if (this.carregarTiposDocumentoCallback) {

            this.carregarTiposDocumentoCallback($(e.target).val());
        }

    },

    buildChildView: function(item, itemView) {

        var view = new itemView({
            model: item,
            app: this.app,
            parent: this
        });
        return view;
    },
});